<template>
  <div class="content">
    <CrearEmpresa :id-cliente="this.clienteId"></CrearEmpresa>
    <ModificarEmpresa></ModificarEmpresa>

    <div class="container-fluid h-100">
      <div class="container-fluid h-100">
        <card-item>
          <div class="d-flex justify-content-end">
            <button
              class="btn btn-danger btn-sm"
              @click="$router.push('/admin/clientes')"
            >
              Volver
            </button>
          </div>
        </card-item>
        <div class="row h-100">
          <div class="col h-100">
            <card-item
              class="striped-tabled-with-hover"
              body-classes="table-full-width table-responsive"
            >
              <template slot="header">
                <div class="d-flex justify-content-between">
                  <div>
                    <!-- <h4 class="card-title">{{ cliente.nombre_web }}</h4> -->
                    <h4 class="card-title">{{ nombreCliente }}</h4>
                    <p class="card-category">Listado de Empresas</p>
                  </div>
                  <div class="button-group">
                    <button @click="crearEmpresa" class="btn btn-primary">
                      Añadir Empresa
                    </button>
                  </div>
                </div>
              </template>

              <div class="container-fluid h-100">
                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <label for="quickFilter" class="label"
                        >Filtro rapido</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="quickFilter"
                        v-model="quickFilter"
                      />
                    </div>
                  </div>
                </div>
                <div class="row" style="height: 100%">
                  <div class="col" style="position: relative; height: 100%">
                    <ag-grid-vue
                      style="width: 100%; height: 60vh"
                      class="ag-theme-alpine"
                      @grid-ready="onGridReady"
                      :gridOptions="gridOptions"
                      :columnDefs="columnDefs"
                      :defaultColDef="defaultColDef"
                      :rowData="rowData"
                      :getContextMenuItems="getContextMenuItems"
                    >
                    </ag-grid-vue>
                  </div>
                </div>
              </div>
            </card-item>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import { get } from "lodash-es";

import CrearEmpresa from "@/pages/Clientes/Empresas/CrearEmpresa";
import EmpresasTabla from "@/pages/Clientes/Empresas/Tabla/EmpresasTabla";
import ModificarEmpresa from "@/pages/Clientes/Empresas/ModificarEmpresa";
import NombreCliente from "../shared/NombreCliente";

export default {
  name: "EmpresasList",
  mixins: [EmpresasTabla, NombreCliente],
  components: { CrearEmpresa, AgGridVue, ModificarEmpresa },
  mounted() {
    this.clienteId = this.$route.params.id_cliente;

    this.getNombreCliente(this.clienteId).then((resp) => {
      if (get(resp, "ok", true) == false) {
        this.$msgBoxOk(resp.message);
      }
      // this.$store
      //   .dispatch("Empresas/getNombreWeb", this.clienteId)
      //   .then((resp) => {
      //     if (get(resp, "ok", true) == false) {
      //       this.$msgBoxOk(resp.message);
      //     }
      //   });
    });
  },
  methods: {
    crearEmpresa() {
      this.$bvModal.show("crearEmpresaModal");
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.api = params.api;
      this.columnApi = params.columnApi;

      this.getEmpresas();
    },
    getContextMenuItems() {
      return ["copy", "excelExport"];
    },
  },
  data: () => ({
    quickFilter: "",
    clienteId: "",

    gridOptions: {
      statusBar: {
        statusPanels: [
          {
            statusPanel: "agTotalAndFilteredRowCountComponent",
            align: "left",
          },
          {
            statusPanel: "agTotalRowCountComponent",
            align: "center",
          },
          { statusPanel: "agFilteredRowCountComponent" },
          { statusPanel: "agSelectedRowCountComponent" },
          { statusPanel: "agAggregationComponent" },
        ],
      },
      enableClipboard: true, // Habilita Ctrl+C/Ctrl+V (por defecto es true)
      enableRangeSelection: true, // Permite seleccionar rangos de celdas
      suppressCopyRowsToClipboard: false, // Asegura que se pueda copiar filas
    },
    defaultColDef: {
      sortable: true,
      filter: true,
      resizable: true,
      flex: 1,
      enableCellTextSelection: true, // Permite seleccionar texto de celdas
      ensureDomOrder: true, // Asegura orden DOM correcto
    },
  }),
  watch: {
    quickFilter(val) {
      this.gridApi.setQuickFilter(val);
    },
  },
};
</script>

<style scoped></style>
